import React, { useState } from 'react';
import { Sample, getSamples } from 'utils/SamplesUtil';
import { useAppContext } from 'hooks/useAppContext';
import SkeletonGrid from 'components/Shared/SkeletonGrid';
import {
  Redirect,
} from "react-router-dom";
import { useTheme } from '@material-ui/core';
import withAppStylesGrid from 'HOCs/withAppStyles';
import withInspectionLink from 'HOCs/withInspectionLink';
import withAttachmentIcons from 'HOCs/withAttachmentsIcons';
import MaterialTable from 'material-table';
import { useCanDoAction } from 'hooks/useCanDoAction';

export default function ActiveGrid({ customFilter }) {
  const columns = Sample.columns // .filter(col =>  col.title !== "baseSampleId" )
  const { selectedProject } = useAppContext(); //Getting the App Context
  const title = "Active Samples";
  const theme = useTheme();
  const [details, setDetails] = useState(false);
  const [sampleID, setSampleID] = useState("");

  const canRead = useCanDoAction('Samples', 'read');

  const sampleDetails = (data) => {
    setSampleID(data.SampleCd)
    setDetails(true)
  };

  const _getRecords = async (page, pageSize, orderBy, orderDirection, search, _filters) => {
    return await getSamples(page, pageSize, orderBy, orderDirection, { Status: "active" }, _filters);
  };

  const GridWithAppStyles = withAttachmentIcons(
    withInspectionLink(
      withAppStylesGrid(MaterialTable,
        {
          theme, getRecords: _getRecords, defaultFilters: { projectId: selectedProject, ...customFilter }
        }),
      { inspectionColumnTitle: "Inspection #" }),
    { attachmentColumnTitle: "Attachments" }
  );

  return (
    <div style={{ padding: '10px' }}>
      {
        details && <Redirect to={`/projects/${selectedProject}/Samples/${sampleID}`} />
      }
      {
        selectedProject ?
          <GridWithAppStyles
            columns={columns}
            title={title}
            customFilter={customFilter}
            options={{
              pageSize: 10,
              pageSizeOptions: [10, 15, 20]
            }}
            actions={canRead ? [{
              icon: 'create_filled',
              tooltip: '',
              onClick: (event, data) => sampleDetails(data)
            }] : []
            }
          /> : <SkeletonGrid title={title} />
      }
    </div>
  )
}